import React from 'react'
import expand from '../../images/expand_caldera.png'

export default function ItemHomeSelection({ index, text }) {
    return (
        <div className="items_selection_home_item">
            <h1>{index}</h1>
            <p>{text}</p>
            <img src={expand} style={{
            }} />
        </div>
    )
}
